import React from "react";
import styled from "styled-components";
import ProcessFold1 from "../components/ProcessPageComponents/ProcessFold1";
import { Outlet } from "react-router-dom";
import ProcessPageSelector from "../components/ProcessPageComponents/ProcessPageSelector";
import ProcessMobileView from "../components/ProcessPageComponents/ProcessMobileView";
import TrackingComponent from "../components/Tracking/TrackingComponent";
import { Helmet } from "react-helmet-async";

const ProcessPage = () => {
  return (
    <>
      <Helmet>
        <title>Our Delivery Process | appssemble</title>
        <meta
          name="description"
          content="appssemble’s delivery process is built for speed, quality, and transparency. Learn how we use cycles, scoping, and lean teams to ship exceptional digital products on time."
        />
        <meta name="robots" content="index, follow" />
        <meta name="author" content="appssemble" />
        <meta name="viewport" content="width=device-width, initial-scale=1" />

        {/* Open Graph / Facebook */}
        <meta property="og:type" content="website" />
        <meta property="og:title" content="Our Delivery Process | appssemble" />
        <meta
          property="og:description"
          content="We deliver digital products in 4–6 week cycles with small, cross-functional teams. Explore our full process from discovery to support and everything in between."
        />
        <meta property="og:url" content="https://appssemble.com/process" />
        <meta
          property="og:image"
          content="https://appssemble.com/appssemble-meta.jpeg"
        />

        {/* Twitter */}
        <meta name="twitter:card" content="summary_large_image" />
        <meta
          name="twitter:title"
          content="Our Delivery Process | appssemble"
        />
        <meta
          name="twitter:description"
          content="From discovery to delivery and support—appssemble’s transparent, cycle-based process ensures fast, high-quality digital product development."
        />
        <meta
          name="twitter:image"
          content="https://appssemble.com/appssemble-meta.jpeg"
        />

        <link rel="canonical" href="https://appssemble.com/process" />
      </Helmet>
      <Wrapper>
        <div className="container-1440 container-content position-relative">
          <Content>
            <ProcessFold1 />
            <div className="showOnBig">
              <ProcessPageSelector />
              <Outlet />
            </div>

            <div className="showOnSmall">
              <ProcessMobileView />
            </div>
          </Content>
        </div>
        <TrackingComponent />
      </Wrapper>
    </>
  );
};

export default ProcessPage;

const Wrapper = styled.div`
  min-height: 100vh;
`;
const Content = styled.div`
  display: flex;
  flex-direction: column;
  row-gap: 50px;
`;
